import clsx from 'clsx';
import StarIcon from './atoms/StarIcon';

interface EditorialButtonProps {
  isEditorial: boolean;
  toggleTag: () => void;
}

export default function EditorialButton({ isEditorial, toggleTag }: EditorialButtonProps) {
  return (
    <div
      className={clsx(
        'w-8 h-8 cursor-pointer rounded-full flex items-center justify-center hover:bg-orange-400 hover:text-white',
        isEditorial ? 'bg-orange-400 text-white' : 'bg-[#888]'
      )}
      onClick={toggleTag}
    >
      <StarIcon />
    </div>
  );
}
